// @flow
import { Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'

type Props = {

};

const Typographies = (props: Props) => {
    const theme = useTheme()
    const color = theme.palette.pageTitle.textColor
    const title = 'Hello World, Καλημέρα Κόσμε'
    return (
        <div>
            <Typography
                variant={'h1'}
                component={'div'}
                color={color}
                mb={1}
            >
                {title}
            </Typography>
            <Typography
                variant={'h2'}
                component={'div'}
                color={color}
                mb={1}
            >
                {title}
            </Typography>
            <Typography
                variant={'h3'}
                component={'div'}
                color={color}
                mb={1}
            >
                {title}
            </Typography>
            <Typography
                variant={'h4'}
                component={'div'}
                color={color}
                mb={1}
            >
                {title}
            </Typography>
            <Typography
                variant={'h5'}
                component={'div'}
                color={color}
                mb={1}
            >
                {title}
            </Typography>
            <Typography
                variant={'h6'}
                component={'div'}
                color={color}
                mb={1}
            >
                {title}
            </Typography>
            <Typography
                variant={'subtitle1'}
                color={color}
                mb={1}
            >
                {title}
            </Typography>
            <Typography
                variant={'subtitle2'}
                color={color}
                mb={1}
            >
                {title}
            </Typography>
            <Typography
                variant={'body1'}
                color={color}
                mb={1}
            >
                {title}
            </Typography>
            <Typography
                variant={'body2'}
                color={color}
                mb={1}
            >
                {title}
            </Typography>
            <Typography
                variant={'button'}
                color={color}
                mb={1}
            >
                {title}
            </Typography>
            <br/>
            <Typography
                variant={'caption'}
                color={color}
                mb={1}
            >
                {title}
            </Typography><br/>
            <Typography
                variant={'overline'}
                color={color}
                mb={1}
            >
                {title}
            </Typography><br/>
        </div>
    )
}

export default Typographies